import wechat from '@/api/common/wechat'
import userinfo from '@/api/common/userinfo'

import auth from '@/api/wechat/auth'
// import userinfo from '@/api/wechat/userinfo'

import customer from '@/api/customer/customer'
import dynamiccode from '@/api/customer/dynamiccode'

import textmessage from '@/api/message/textmessage'

export default {
    common:{
        wechat:wechat,
        userinfo:userinfo,
    },
    wechat: {
        auth: auth,
  
    },
    customer : {
        customer: customer,
        dynamiccode:dynamiccode,
    },
    message:{
        textmessage:textmessage,
    },
}


// WEBPACK FOOTER //
// ./src/api/index.js